import { useState } from "react";
import axios from "axios";
import { ICreateDownlineRequest } from "./createDownline.models";
import { CreateDownline } from "./createDownline.services";

export const useCreateDownline = () => {
    const [createDownlineLoading, setCreateDownlineLoading] = useState(false);

    const handleCreateDownline = async (payload: ICreateDownlineRequest) => {
        setCreateDownlineLoading(true);
        try {
            return await CreateDownline(payload);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            console.error(error);
        } finally {
            setCreateDownlineLoading(false);
        }
    };

    return {
        createDownlineLoading,
        handleCreateDownline,
    };
};
